import * as React from 'react';
import Accordion from './Accordion';
import '../css/accordion.sass';
import { HatType } from './Hat';

interface AccordionGroupOption {
  title: React.ReactNode;
  id: string;
  panel: React.ReactNode;
  expanded?: boolean;
  hat?: HatType[];
  onExpand?: Function;
  lazyLoad?: boolean;
  theme?: 'day' | 'night';
  flipBg?: boolean;
  isDivider?: boolean;
}
interface AccordionGroupProps {
  options?: AccordionGroupOption[];
  children?: React.ReactNode[];
  isTogglePanels?: boolean;
}

interface AccordionGroupState {
  expandedIndex?: number;
}

export default function AccordionGroup(props: AccordionGroupProps) {
  const [state, setState] = React.useState<AccordionGroupState>({});

  const { isTogglePanels = false } = props;

  const options =
    props.options ||
    React.Children.toArray(props.children).filter((child: any) => {
      return React.isValidElement(child) && child.type !== React.Fragment;
    });

  const updatedExpandedIndex = () =>
    options.findIndex((option: AccordionGroupOption | any) => {
      return option.props ? option.props.expanded : option.expanded;
    });

  React.useEffect(() => {
    if (updatedExpandedIndex() !== state.expandedIndex) {
      setState({ ...state, expandedIndex: updatedExpandedIndex() });
    }
  }, [updatedExpandedIndex()]);

  let keyIndex = 0;

  return (
    <div>
      {options?.map((option: AccordionGroupOption | any, index: number) => {
        keyIndex += 1;
        return (
          <Accordion
            key={`${option.title ||
              option.props?.title
                ?.toString()
                .toLowerCase()
                .replace(' ', '')}${keyIndex}`}
            id={option.id || option.props?.id}
            expanded={
              state.expandedIndex !== undefined && index === state.expandedIndex
            }
            onExpand={(expanded: boolean) => {
              if (!isTogglePanels) {
                setState({ expandedIndex: expanded ? index : undefined });
              } else if (option.onExpand !== undefined) {
                option.onExpand();
              } else if (option.props && option.props.onExpand) {
                option.props.onExpand();
              }
            }}
            title={option.title || option.props?.title}
            hat={option.hat || option.props?.hat}
            lazyLoad={option.lazyLoad || option.props?.lazyLoad}
            theme={option.theme || option.props?.theme}
            flipBg={option.flipBg || option.props?.flipBg}
            isDivider={option.isDivider || option.props?.isDivider}
          >
            {option.panel || option.props?.children}
          </Accordion>
        );
      })}
    </div>
  );
}
